import { FormInstance } from 'antd/lib/form';
import React from 'react';
import { LabelAndKey } from './types/LabelAndKey';
import GenericSearchSelector from './GenericSearchSelector';

interface Props {
    dependencies?: string[]
    fieldValidator?(rule: any, value: any): Promise<void>
    criterion?: any
    form: FormInstance
}

const HRGSelector = ({dependencies, fieldValidator, criterion, form}: Props) => {

    const toLabel = (e: LabelAndKey) => {
        return e.key + " - " + e.label
    }

    return <GenericSearchSelector
        fieldId="hrgs"
        fieldLabel="HRG"
        fieldURL="/mapping?category=sushrg"
        dependencies={dependencies}
        fieldValidator={fieldValidator}
        fieldLabelFunction={toLabel}
        criterion={criterion}
        form={form}
    />
}

export default HRGSelector